// Spinner de chargement PBP
import React from 'react';
import { clsx } from 'clsx';

interface Props {
  fullScreen?: boolean;
  size?: 'sm' | 'md' | 'lg';
  text?: string;
}

export default function LoadingSpinner({ fullScreen, size = 'md', text }: Props) {
  const sizes = { sm: 'w-4 h-4', md: 'w-8 h-8', lg: 'w-12 h-12' };

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white dark:bg-gray-900 flex items-center justify-center z-50">
        <div className="text-center">
          <div className={clsx('animate-spin rounded-full border-4 border-primary-200 border-t-primary-600 mx-auto', sizes.lg)} />
          <p className="mt-4 text-sm text-gray-500">Chargement de PBP Guinée...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center gap-3 py-8">
      <div className={clsx('animate-spin rounded-full border-2 border-primary-200 border-t-primary-600', sizes[size])} />
      {text && <span className="text-sm text-gray-500">{text}</span>}
    </div>
  );
}
